<pcs-multi-select
  [disabled]="showOnlyRowsWithNoOptions || filterByColor"
  [selected]="selectedOptions"
  [options]="options$ | async"
  displayProperty="name"
  (selectionChanged)="onOptionSelected($event)"
  class="mb-2">
</pcs-multi-select>

<pcs-checkbox
  inputId="filterByColor"
  label="search.filterByColor"
  [checked]="filterByColor"
  (selectionChanged)="onFilterByColorChanged($event)"
  [disabled]="showOnlyRowsWithNoOptions">
</pcs-checkbox>

<div class="mb-2">
  <pcs-color-picker [colors]="colorOptions"
                    [multiSelection]="true"
                    [value]="selectedColorOptions"
                    (selectionChanged)="onColorOptionSelected($event)"
                    [disabled]="showOnlyRowsWithNoOptions || !filterByColor">
  </pcs-color-picker>
</div>

<pcs-checkbox
  inputId="showDossiersWithNoLabels"
  label="search.showOnly.dossiersWithNoLabels"
  [checked]="showOnlyRowsWithNoOptions"
  [disabled]="filterByColor"
  (selectionChanged)="onShowOnlyRowsWithNoOptionsChanged($event)">
</pcs-checkbox>
